/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Subject_Required1Inputs */

const en_support_submitticket_subject_required1 = /** @type {(inputs: Support_Submitticket_Subject_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject is required`)
};

/**
* | output |
* | --- |
* | "Subject is required" |
*
* @param {Support_Submitticket_Subject_Required1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_subject_required1 = /** @type {((inputs?: Support_Submitticket_Subject_Required1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Subject_Required1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_subject_required1(inputs)
});
export { support_submitticket_subject_required1 as "support_submitTicket_subject_required" }